import { FC, useEffect } from 'react';
import { useBriefingState } from '../features/Briefing/BriefingState';
import { capitalise } from '../lib/utils';
import { TrackingSchema } from '../types';
import { useGTM } from './useGTM';

export type GTMEventData<
  T = {
    [key: string]:
      | string
      | boolean
      | undefined
      | { [key: string]: string | string[] };
  },
> = {
  event: string;
  schema: TrackingSchema;
  data: T;
};

export type GTMPageTrackingDataProps = {
  category?: string;
  type?: string;
  content?: string;
  getBranchFromState?: boolean;
};

type PageTrackerProps = {
  children: React.ReactNode;
  gtmTrackingData?: GTMEventData;
};

export const GTMBaseContentViewObject = {
  event: 'Content View',
  schema: TrackingSchema.content,
};

export const PageTracker: FC<PageTrackerProps> = ({
  children,
  gtmTrackingData,
}) => {
  const [{ branch }] = useBriefingState();
  const { gtmIsInitialized, updateDataLayer } = useGTM();

  useEffect(() => {
    if (!gtmIsInitialized || !window.dataLayer || !gtmTrackingData) return;

    if (gtmTrackingData.data?.getBranchFromState) {
      gtmTrackingData.data.category = capitalise(branch);
    }

    updateDataLayer(gtmTrackingData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gtmIsInitialized]);

  return <>{children}</>;
};
